import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/shadows.stylex';
import { shadows } from '@tokens/shadows.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Shared action-menu dropdown (see Menu). Mirrors the SiteSwitcher dropdown look.
export const styles = {
  wrap: {
    kVAEAm: "x1n2onr6",
    k1xSpc: "x1rg5ohu",
    $$css: true
  },
  menu: {
    kVAEAm: "x10l6tqk",
    k87sOh: "xwwefxd",
    kY2c9j: "xf5e64p",
    k7Eaqz: "x1jzhcrs",
    kmVPX3: "xrqf348",
    kWkggS: "x13uruat",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xaj8nyx",
    kaIpWk: "xxltkoq",
    kGVxlE: "xkqgayn",
    $$css: true
  },
  alignLeft: {
    kbCHJM: "xu96u03",
    $$css: true
  },
  alignRight: {
    kCIrl2: "x3m8u43",
    $$css: true
  },
  item: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1mnnc3i",
    kzqmXN: "xh8yej3",
    k8WAf4: "xyggvxn",
    kg3NbH: "x1l89hgl",
    kaIpWk: "x1d0dq8e",
    kWkggS: "xjbqb8w",
    kMzoRj: "xc342km",
    kkrTdU: "x1ypdohk x1s07b3s",
    kMv6JI: "xdv2sak",
    kGuDYH: "x4z9k3i",
    k63SB2: "xssbmp7",
    kMwMTN: "xdxw5r1",
    k9WMMc: "xdpxx8g",
    khDVqt: "xuxw1ft",
    kmkexE: "x1k3q35m",
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    kGzVvX: "x5lqt2c",
    kDPRdz: "x1tqbdv0",
    $$css: true
  },
  itemDanger: {
    kMwMTN: "x2wi9gy",
    kGzVvX: "x5lqt2c",
    kDPRdz: "xfahpnm",
    $$css: true
  },
  itemDisabled: {
    kSiTet: "xbyyjgo",
    kGzVvX: "x1n5bzlp",
    kDPRdz: "x1csad40",
    $$css: true
  },
  icon: {
    k1xSpc: "x3nfvp2",
    kmuXW: "x2lah0s",
    kMwMTN: "x15rks2t",
    $$css: true
  },
  label: {
    kUk6DE: "x98rzlu",
    k7Eaqz: "xeuugli",
    $$css: true
  }
};